import React from "react";

const Washing_30 = React.forwardRef(
  ({ width = "32", height = "32", viewBox = "0 0 32 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0925 17.813L11.5044 12H9L11.7487 21H14.192L16 15.7838L17.808 21H20.2513L23 12H20.4956L18.9075 17.813L16.9529 12H15.0471L13.0925 17.813Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_30;
